import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Tooltip from '@mui/material/Tooltip'
import Grid from '@mui/material/Grid'
import QuestionAnswerTwoToneIcon from '@mui/icons-material/QuestionAnswerTwoTone';
import _ from 'lodash';
import LocalFireDepartmentTwoTone from '@mui/icons-material/LocalFireDepartmentTwoTone';
import LeadDataFormater from '../../leads/view/LeadDataFormater';
import { DuplicateLead, Lead } from './LeadDataGridStore';
import { useTheme } from '@mui/material'
import ProgressChart from '../../common/ProgressChart'

type Props = {
    lead: DuplicateLead
}


const DuplicateLeadCard = ({ lead }: Props) => {
    const theme = useTheme();

    return <Box sx={{ p: 3 }}>
        <Card sx={{ mb: 6 }} data-testid="activity-timeline" key={lead.id}>
            <CardContent sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                <Grid container spacing={2} justifyContent={'center'} alignItems={'center'}>
                    <Grid xs={4}>                        
                        <ProgressChart subHeading={lead.exactMatch ? "Exact Match" : "% Match"} seriesValue={lead.rank} toolTip="Rank" />
                        {/*{<Typography variant='h6'>*/}
                        {/*    Exact Match: {lead.exactMatch}*/}
                        {/*</Typography>*/}
                    </Grid>
                    <Grid item xs={4} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                        <Grid item xs={12} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                            <Typography variant='h6'>
                                {lead.firstName} {lead.lastName}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                            <LeadDataFormater labelText='' valueText={lead.jobTitle} textColor='CornflowerBlue' errorText='-Job Title is missing-' chipHeight={20} chipFontSize='0.875rem' chipfontWeight={500} isChip={false} />
                            {lead.company != null &&
                                <LeadDataFormater labelText='at' valueText={lead.company} textColor='CornflowerBlue' errorText='-Company is missing-' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                            }
                        </Grid>
                        <Grid item xs={12} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                            <Box sx={{ display: 'flex', alignItems: 'right' }}>
                                {lead.isHot &&
                                    <Tooltip title="Is a Hot Lead">
                                        <LocalFireDepartmentTwoTone sx={{ color: 'FireBrick' }} />
                                    </Tooltip>
                                }
                                {lead.hasMI &&
                                    <Tooltip title="Has a Meaningful Interaction">
                                        <QuestionAnswerTwoToneIcon sx={{ color: 'LightSeaGreen' }} />
                                    </Tooltip>
                                }
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid item xs={4} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                        <Grid item xs={12} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                            <Box sx={{ display: 'flex', alignItems: 'right' }}>
                                <LeadDataFormater labelText='' valueText={lead.stageName} textColor={lead.stageColor} errorText='-Not Set-' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={true} />
                            </Box>
                        </Grid>
                        <Grid item xs={12} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                            <Box sx={{ display: 'flex', alignItems: 'right' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    {lead.country != '' &&
                                        <Tooltip title="Country" >
                                            <Typography variant="caption" >{lead.country}</Typography>
                                        </Tooltip>
                                    }
                                    {lead.country == '' &&
                                        <Tooltip title="Country" >
                                            <Typography variant="caption" >-Country Not Assigned-</Typography>
                                        </Tooltip>
                                    }
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                            <Box sx={{ display: 'flex', alignItems: 'right' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    {lead.leadOwnerName != '' &&
                                        <Tooltip title="Primary lead owner" >
                                            <Typography variant="caption" sx={{ fontStyle: 'italic' }} >Owner: {lead.leadOwnerName}</Typography>
                                        </Tooltip>
                                    }
                                    {lead.leadOwnerName == '' &&
                                        <Tooltip title="Primary lead owner" >
                                            <Typography variant="caption" sx={{ fontStyle: 'italic' }} >Owner: -Not Assigned-</Typography>
                                        </Tooltip>
                                    }
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                            <Box sx={{ display: 'flex', alignItems: 'right' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    {lead.sprintName != '' &&
                                        <Tooltip title="Primary lead owner" >
                                            <Typography variant="caption" sx={{ fontStyle: 'italic' }} >Sprint: {lead.sprintName}</Typography>
                                        </Tooltip>
                                    }
                                    {lead.sprintName == '' &&
                                        <Tooltip title="Primary lead owner" >
                                            <Typography variant="caption" sx={{ fontStyle: 'italic' }} >Sprint: -Not Assigned-</Typography>
                                        </Tooltip>
                                    }
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    </Box>
}

export { DuplicateLeadCard }

export default DuplicateLeadCard;